import { Box, Button, Typography } from '@mui/material';
import React from 'react';

interface IProps {
  handleBack: Function;
  handleNext: Function;
}

export const StartLandRegisterQuery: React.FC<IProps> = props => {
  return (
    <>
      <Box sx={{ mt: 5 }} />
      <Typography variant='h4' sx={{ mb: 3 }}>
        Grundbuchauszug
      </Typography>

      <Typography>
        Herzlich willkommen!
        <br />
        Über unsere Webseite können Sie schnell und unkompliziert einen
        aktuellen Grundbuchauszug anfordern. Der Auszug enthält alle wichtigen
        Informationen zum Eigentum, zu Rechten und Belastungen eines Grundstücks
        oder einer Immobilie.
        <p />
        Bitte beachten Sie: Für die Antragstellung ist ein berechtigtes
        Interesse erforderlich (z. B. als Eigentümer, Käufer oder
        Bevollmächtigter). Nach dem Absenden Ihrer Anfrage prüfen wir Ihre
        Angaben.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button onClick={() => props.handleNext()} variant='contained'>
          Weiter
        </Button>
      </Box>
    </>
  );
};
